export class CfetPageNamesConstant {
    public static CUSTOMER_ELIGIBILITY = 'cfet-eligibility';
    public static CUSTOMER_ELIGIBILITY_UTF = 'eligibility';
    public static CUSTOMER_LANDING = 'landing';
    public static CUSTOMER_LANDING_UTF_NEW = 'orgAssignment';
    public static CUSTOMER_PERSONAL_INFORMATION = 'cfet-information';
    public static CUSTOMER_PERSONAL_INFORMATION_UTF = 'information';
    public static CUSTOMER_PROFILE = 'cfet-profile';
    public static CUSTOMER_PROFILE_UTF = 'profile';
    public static AFFILIATION_CODE = 'cfet-affiliationCode';
    public static AFFILIATION_CODE_UTF = 'affiliationCode';
    public static COMPLETE_PROFILE_CONFIRMATION = 'cfet-confirmation';
    public static COMPLETE_PROFILE_CONFIRMATION_UTF = 'confirmation';
    public static SESSION_TIME_OUT = 'cfet-session-time-out';
    public static SESSION_TIME_OUT_UTF = 'session-time-out';
    public static ERROR_PAGE = 'cfet-page-not-found';
    public static ERROR_PAGE_UTF = 'page-not-found';
    public static UTF_REGISTRATION = 'utf-registration';
    public static UTF_AUTH_PAGE = 'utf-auth-page';
    public static UTF_UNAUTH_PAGE =  'accessidMitigation';
    public static UTF_SYNC_DETAILS_PAGE = 'utf-sync-details-page';
    public static  UTF_SYNCING_INFO = 'utf-syncing-info';
    public static UTF_AUTH_SINGLE_ID_PAGE = 'auth-single-id';
}
